import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    if (username === "admin" && password === "1234") {
      localStorage.setItem("auth", "true");
      navigate("/");
    } else {
      alert("Invalid Username or Password");
    }
  };

  return (
    <Container maxWidth="xs">

      <Paper
        elevation={4}
        sx={{
          p: 4,
          mt: 10,
          textAlign: "center"
        }}
      >

        {/* LOGO */}
        <Box sx={{ mb: 2 }}>
          <img
            src="/gmobiles.jpg"
            alt="G Mobiles"
            style={{ height: 80 }}
          />
        </Box>

        {/* TITLE */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Login
        </Typography>

        {/* USERNAME */}
        <TextField
          fullWidth
          label="Username"
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        {/* PASSWORD */}
        <TextField
          fullWidth
          type="password"
          label="Password"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {/* LOGIN BUTTON */}
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleLogin}
        >
          Login
        </Button>

      </Paper>

    </Container>
  );
}
